import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4921b72b"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href", "title"]
const _hoisted_2 = { class: "link-tile-external" }
const _hoisted_3 = ["src"]

import { ref } from 'vue';
import { LinkDataExternal } from '@/models/data';

export default /*#__PURE__*/_defineComponent({
  __name: 'LinkTileExternal',
  props: {
    data: null
  },
  setup(__props: any) {

const props = __props as {
  data: LinkDataExternal
}

_useCssVars(_ctx => ({
  "6f049a04": (color.value)
}))


const color = ref(props.data.color)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    class: "link-tile-external-wrapper",
    href: __props.data.url,
    target: "_blank",
    title: __props.data.alt
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: require(`@/assets/links/${__props.data.icon}`)
      }, null, 8, _hoisted_3)
    ])
  ], 8, _hoisted_1))
}
}

})